import { render, staticRenderFns } from "./BannerListView.vue?vue&type=template&id=50bc9172&scoped=true"
import script from "./BannerListView.vue?vue&type=script&lang=js"
export * from "./BannerListView.vue?vue&type=script&lang=js"
import style0 from "./BannerListView.vue?vue&type=style&index=0&id=50bc9172&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bc9172",
  null
  
)

export default component.exports